export const normalizeGraphicsData = graphics =>
  graphics.map(({ rolesWithAccess, ...restGraphicData }) => ({
    ...restGraphicData,
    rolesWithAccess: rolesWithAccess ?? [],
  }));
